import { titleCase } from '@westhetics/ui'
import type { Practitioner } from './api'

/** "Camila Castro · CRM 123456"; sem registro, só o conselho; sem profissional, a frase neutra. */
export function practitionerLine(p: Practitioner | null): string {
  if (!p) return 'Sem profissional responsável registrada'
  const registration = [p.councilCode, p.registrationNumber].filter(Boolean).join(' ')
  return registration ? `${titleCase(p.name)} · ${registration}` : titleCase(p.name)
}
